import { IFormResponses } from '@llws/lift-entity-interfaces';
import { ActionContext } from 'vuex';
import { Equal, IQueryCommandOptions, IFilterPayload, convertQueryCommandToQueryString } from '@/shared';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/form_responses';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'form',
      alias: 'form',
    },
    {
      path: 'prospect',
      alias: 'prospect',
    },
    {
      path: 'building',
      alias: 'building',
    },
  ],
  where: [
    Equal('status', 'enabled'),
  ],
  orderBy: [{ field: 'created', direction: 'desc' }],
};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementation<IFormResponses>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'form-responses/'

  state: {
    ...base.state,
  },

  getters: {
    uniqueNames(state: any) {
      const nameOptions: any = [];
      if (state.list?.data || [].length > 0) {
        const unique = Array.from(new Set(state.list.data.map((item: IFormResponses) => item.form?.name)));
        unique.forEach((element) => {
          nameOptions.push({ value: element, text: element });
        });
      }
      return nameOptions;
    },
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    getFormNames: async (ctx: ActionContext<any, any>, payload: IFilterPayload) => {
      const url = adminGatewayResourcePath
      + (payload.filters ? convertQueryCommandToQueryString(payload.filters!) : '');
      const response = await adminRequest.get(url);
      ctx.commit('set', { response, type: payload.additional?.type });
    },
    ...base.actions,
  },
};
